// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {QualifiedTeacherScreenLayout} from 'app_components/screens/qualifiedTeacher'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import QualifiedTeacherService from 'app_services/admin/qualifiedTeacher/qualifiedTeacherService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { INewQualifiedTeacher, IQualifiedTeacherListItem , IQualifiedTeachersHttpResponse} from 'app_types/admin/qualifiedTeacher/qualifiedTeacherTypes'
// @end

// @ADD Component types
interface IQualifiedTeacherScreenProps {
  match?: any
}
interface IQualifiedTeacherScreenState {
  status: null | 'loading' | 'error'
  teacherList: IQualifiedTeacherListItem[]
  add: boolean
  edit: boolean
  view: boolean
  editData: null | IQualifiedTeacherListItem
  selectedRow: null | string
  pagination: IPagination
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class QualifiedTeacherScreen extends Component<IQualifiedTeacherScreenProps, IQualifiedTeacherScreenState> {

  public moduleName: string = 'module:qualifiedTeacher'
  private permission: PermissionService
  private screenNotifications: ScreenNotificationsUtil
  private teacherService: QualifiedTeacherService
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IQualifiedTeacherScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      teacherList: [],
      add: false,
      edit: false,
      view: false,
      editData: null,
      selectedRow: null,
      pagination: {
        page: 1,
        perPage: 50,
        total: 0,
      },
    }

    this.permission = new PermissionService(this.moduleName)
    this.screenNotifications = new ScreenNotificationsUtil()
    this.teacherService = new QualifiedTeacherService()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getTeacherList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods


  onRowClick = async (row: any) => {
    if (this.state.selectedRow === row._id) {
      this.setState({ selectedRow: null })
    } else {
      // this.setState({ status: 'loading' })
      const user: any = this.state.teacherList.find((user) => user._id === row._id)

      if (!user?.details) {
        await this.getTeacher(row._id)
      }

      this.setState({
        selectedRow: row._id,
        // status: null,
      })
    }
  }

  showAddUserForm = async (add: boolean) => {
    this.setState({ add })
  }

  showEditUserForm = async (edit: boolean, user?: any) => {
    if (edit && user) {
      await this.getTeacher(user._id)
      this.setState({ edit: true, editData: user })
    } else {
      this.setState({ edit: false })
    }
  }

  onViewerRow = async (view: boolean, register?: any) => {
    if (view && register) {
      await this.getTeacher(register._id)
      this.setState({ view: true, editData: register })
    } else {
      this.setState({ view: false })
    }
  }

  onPageChange = async (page: number) => {
    this.getTeacherList({ page })
  }

  onSearch = async (event: any) => {
    this.getTeacherList({ page: 1, search: event.search })
    return false
  }

  showModal = async () => {}

  getTeacher = async (userId: string) => {}

  getTeacherList = async (params?: any) => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    let teacherList: IQualifiedTeachersHttpResponse | null = await this.teacherService.list(httpParams);//httpParams)

    if (teacherList?.status_code === 'success') {
      this.setState({
        teacherList: teacherList?.qualifiedTeachers,
        pagination: {
          total: teacherList?.total_register,
          perPage: teacherList?.nPerPage,
          page: teacherList?.pageNumber,
        },
        status: null,
      })
    } else {
      this.setState({ status: 'error' })
    }


  }

  addTeacher = async (userResponse: any) => {
  }

  updateTeacher = async (userResponse: INewQualifiedTeacher) => {
  }

  removeTeacher = async (userId: string) => {
  }

  render() {
    return(
      <QualifiedTeacherScreenLayout
        add={this.permission.check('permission:qualifiedTeacher_create', this.state.add)}
        edit={this.permission.check('permission:qualifiedTeacher_update', this.state.edit)}
        view={this.permission.check('permission:qualifiedTeacher_viewer', this.state.view)}
        editData={this.state.editData}
        onRowClick={this.onRowClick}
        onViewerRow={this.permission.check('permission:qualifiedTeacher_viewer', this.onViewerRow)}
        selectedRow={this.state.selectedRow}
        showAddUserForm={this.permission.check('permission:qualifiedTeacher_create', this.showAddUserForm)}
        showEditUserForm={this.permission.check('permission:qualifiedTeacher_update', this.showEditUserForm)}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        teacherList={this.permission.check('permission:qualifiedTeacher_list', this.state.teacherList)}
        addTeacher={this.permission.check('permission:qualifiedTeacher_create', this.addTeacher)}
        updateTeacher={this.permission.check('permission:qualifiedTeacher_update', this.updateTeacher)}
        removeTeacher={this.permission.check('permission:qualifiedTeacher_delete', this.removeTeacher)}
        onSearch={this.permission.check('permission:qualifiedTeacher_list', this.onSearch)}

        status={this.state.status}
        showModal={this.showModal}
      />
    )
  }
}

export default connect(mapStatesToProps)(QualifiedTeacherScreen)
